import React, { useState } from 'react';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Header from '../components/Header';
import Message from '../components/LoadingError/Error';
import Loading from '../components/LoadingError/Loading';
import { findPreorder, updatePreorder } from '../service/OrdersService';

const UserInfoScreen = ({ user }) => {
  const [userInfo, setUserInfo] = useState({
    name: '',
    lastName: '',
    email: '',
    phone: '',
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();

  const navigate = useNavigate();
  const params = useParams();
  const preorderId = params.id;

  useEffect(() => {
    if (user) {
      findPreorder(preorderId).then((preorder) => {
        if (!preorder) {
          navigate('/cart');
        }
        if (preorder[0]?.user)
          setUserInfo({
            name: preorder[0].user.name,
            lastName: preorder[0].user.lastName,
            email: preorder[0].user.email,
            phone: preorder[0].user.phone,
            address: preorder[0].user.address,
            city: preorder[0].user.city,
            postalCode: preorder[0].user.postalCode,
            country: preorder[0].user.country,
          });
        else {
          setUserInfo({
            name: user.name,
            lastName: user.lastName,
            email: user.email,
            phone: user.phone,
          });
        }
        setLoading(false);
      });
    }
  }, [user]);

  const handleUserInfo = (e) => {
    setUserInfo({ ...userInfo, [e.name]: e.value });
  };

  const submitHandler = (e) => {
    e.preventDefault();

    updatePreorder({ user: userInfo }, preorderId)
      .then(() => navigate(`/user-address/${preorderId}`))
      .catch((error) => setError(error.response.data.message));
  };
  return (
    <>
      <Header searcherDisabled={true} shopLink={true} />
      <div className='container d-flex justify-content-center align-items-center mt-md-5'>
        {error && <Message variant='alert-danger'>{error}</Message>}
        {loading ? (
          <Loading />
        ) : (
          <form
            className='Login col-md-8 col-lg-4 col-11'
            onSubmit={submitHandler}
          >
            <h6>INFORMACIÓN</h6>
            <input
              type='text'
              placeholder='Introducir el nombre'
              value={userInfo.name}
              name='name'
              required
              onChange={(e) => handleUserInfo(e.target)}
            />
            <input
              type='text'
              placeholder='Introducir el apellido'
              value={userInfo.lastName}
              name='lastName'
              required
              onChange={(e) => handleUserInfo(e.target)}
            />
            <input
              type='text'
              placeholder='Introducir el email'
              value={userInfo.email}
              name='email'
              required
              onChange={(e) => handleUserInfo(e.target)}
            />
            <input
              type='text'
              placeholder='Introducir el teléfono'
              value={userInfo.phone}
              name='phone'
              maxLength={9}
              minLength={9}
              required
              onChange={(e) => handleUserInfo(e.target)}
            />
            <button
              disabled={
                !userInfo.name?.length > 0 ||
                !userInfo.lastName?.length > 0 ||
                !userInfo.email?.length > 0 ||
                !userInfo.phone?.length > 0
              }
              style={{
                backgroundColor:
                  (!userInfo.name?.length > 0 ||
                    !userInfo.lastName?.length > 0 ||
                    !userInfo.email?.length > 0 ||
                    !userInfo.phone?.length > 0) &&
                  'grey',
              }}
              type='submit'
            >
              Continuar
            </button>
          </form>
        )}
      </div>
    </>
  );
};

export default UserInfoScreen;
